// extracted by mini-css-extract-plugin
export default {"carousel":"focused-layout_carousel__HMQT+","focused":"focused-layout_focused__ShCdX","focusLayout":"focused-layout_focusLayout__Zgpdm"};